<div
  class="image-container align-items-center justify-content-start justify-content-md-between"
>
  <atx-image
    atxCardImage="top"
    data-e2e="cbasket-sellable-image"
    [imageUrl]="imageUrl"
    [maxWidth]="imageMaxSizes.ICON"
    failedLoadIconSize="1x"
    fallbackImageUrl="static/images/placeholder-image.jpg"
    (click)="$event.preventDefault(); thumbClick.emit(csPath)"
  ></atx-image>
  <div data-e2e="sellable-row-title">
    @if (title) {
    <p [atxTooltip]="title" class="my-0 ml-0 truncate-overflow">
      {{ title }}
    </p>
    }
    <p data-e2e="articleId" class="m-0 text-muted">
      {{ number }}
    </p>
  </div>
</div>
